import React from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { SxProps, Theme } from '@mui/system';

const label = { inputProps: { 'aria-label': 'Checkbox custom' } };

type CheckboxCustomProps = {
  value: number | string;
  label: string;
  checked: boolean;
  sx?: SxProps<Theme>;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const CheckboxCustom: React.FC<CheckboxCustomProps> = (props) => {
  return (
    <Box display='flex' alignItems='center' sx={props.sx}>
      <FormControlLabel
        control={
          <Checkbox
            {...label}
            sx={{
              width: '24px',
              height: '24px',
              color: '#A3AED0',
            }}
            checked={props.checked}
            onChange={props.onChange}
            value={props.value}
          />
        }
        sx={{
          ml: '4px',
          fontWeight: '500',
          fontSize: '14px',
        }}
        label={props.label}
      />
    </Box>
  );
};

export default CheckboxCustom;
